import React, { useState, useEffect } from 'react'

export function StreamKeyCard({ token, user }) {
  const [key, setKey] = useState(null)
  const [loading, setLoading] = useState(true)
  const [copiedOverlay, setCopiedOverlay] = useState(false)
  const [planRequired, setPlanRequired] = useState(false)

  const loadKey = () => {
    setLoading(true)
    fetch('/api/user/stream-key', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        if (d.planRequired) {
          setPlanRequired(true)
        } else if (d.streamKey) {
          setKey(d.streamKey)
          setPlanRequired(false)
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (token) loadKey()
  }, [token])

  const rollKey = () => {
    if (!window.confirm('¿Regenerar clave? La anterior dejará de funcionar en OBS.')) return
    fetch('/api/user/stream-key/roll', { method: 'POST', headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.streamKey) setKey(d.streamKey) })
      .catch(() => {})
  }

  const overlayUrl = key ? `${window.location.origin}/overlay/${key}` : ''

  const copy = (text, setFn) => {
    navigator.clipboard?.writeText(text)
    setFn(true)
    setTimeout(() => setFn(false), 2000)
  }

  const cardS = {
    background: 'var(--card-bg)', border: '1px solid var(--border)',
    borderRadius: 16, padding: '20px 22px', marginBottom: 14,
  }
  const labelS = {
    fontSize: 12, fontWeight: 700, color: 'var(--text-faint)',
    textTransform: 'uppercase', letterSpacing: 0.8, margin: 0,
  }

  if (loading) return null

  return (
    <div style={cardS}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <p style={labelS}>API de Streaming & OBS (Twitch / YouTube)</p>
        <span style={{ fontSize: 10, fontWeight: 800, padding: '2px 7px', borderRadius: 6, background: planRequired ? 'rgba(142,142,147,0.15)' : 'rgba(255,59,48,0.15)', color: planRequired ? 'var(--text-faint)' : '#ff3b30' }}>
          {planRequired ? 'REQUIERE PLAN PRO' : 'PREMIUM'}
        </span>
      </div>

      <p style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5, marginBottom: 14 }}>
        Transmití tu pulso y estrés en vivo a tu audiencia en OBS Studio, Streamlabs o plataformas externas.
      </p>

      {planRequired ? (
        <div style={{ background: 'var(--field-bg)', borderRadius: 12, padding: '14px 16px', border: '1px solid var(--border-soft)' }}>
          <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', margin: '0 0 6px' }}>Función exclusiva para creadores y atletas</p>
          <p style={{ fontSize: 12, color: 'var(--text-faint)', margin: '0 0 12px' }}>
            Mejorá tu plan para obtener tu clave secreta de transmisión y widget transparente para OBS.
          </p>
          <a href="/register" style={{ display: 'inline-block', background: '#ff3b30', color: '#fff', padding: '8px 16px', borderRadius: 8, fontSize: 12.5, fontWeight: 700, textDecoration: 'none' }}>
            Ver planes disponibles →
          </a>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <p style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-faint)', marginBottom: 5 }}>Widget para OBS (Navegador / Browser Source):</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                readOnly
                value={overlayUrl}
                style={{ flex: 1, background: 'var(--field-bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: 'var(--text)', fontFamily: 'monospace', outline: 'none' }}
              />
              <button
                onClick={() => copy(overlayUrl, setCopiedOverlay)}
                style={{ background: copiedOverlay ? '#34c759' : 'var(--chip-bg)', color: copiedOverlay ? '#fff' : 'var(--text)', border: 'none', borderRadius: 8, padding: '0 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
              >
                {copiedOverlay ? '✓ Copiado' : 'Copiar'}
              </button>
            </div>
            <p style={{ fontSize: 10.5, color: 'var(--text-faint)', marginTop: 4 }}>
              Agregá esta URL como fuente de navegador en OBS Studio. Fondo transparente incluido.
            </p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid var(--border-soft)', paddingTop: 10 }}>
            <div>
              <span style={{ fontSize: 11, color: 'var(--text-faint)' }}>Stream Key: </span>
              <code style={{ fontSize: 11, color: 'var(--text)', background: 'var(--field-bg)', padding: '2px 6px', borderRadius: 4 }}>{key ? key.slice(0, 8) + '••••••••' : ''}</code>
            </div>
            <button
              onClick={rollKey}
              style={{ background: 'none', border: 'none', color: '#ff3b30', fontSize: 11.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}
            >
              ↻ Regenerar clave
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

